"use client";

import styled from "styled-components";

//Types
import { ImageProps } from "@/types";

export const ImageComponent = styled.img<ImageProps>`
  max-width: 100%;
  max-height: 100%;

  cursor: ${({ onClick }) => (onClick ? "pointer" : "normal")};
`;
